/**
 * Inline marketing column — used inside a 2-col grid alongside Recent Jobs.
 * Same data source as the global ad top bar, just rendered inline.
 */
import { useEffect, useState } from "react";
import axios from "axios";
import { ExternalLink, Megaphone } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const InlineMarketingColumn = () => {
  const [ads, setAds] = useState([]);

  useEffect(() => {
    axios.get(`${API}/ads/active`)
      .then(r => setAds((r.data?.ads || []).slice(0, 3)))
      .catch(() => {});
  }, []);

  return (
    <div
      className="rounded-3xl p-5 sm:p-6 border border-white/10 text-white h-full"
      style={{ background: 'linear-gradient(135deg, #0A1A3E 0%, #0F2557 100%)' }}
      data-testid="marketing-column"
    >
      <div className="flex items-center gap-2 mb-4">
        <Megaphone className="w-4 h-4 text-[#60a5fa]" />
        <h2 className="text-lg font-bold tracking-tight" style={{ fontFamily: 'Chivo, sans-serif' }}>Marketing & Ads</h2>
      </div>
      {ads.length === 0 ? (
        <div className="text-center py-8 bg-white/[0.03] border border-white/10 rounded-2xl">
          <Megaphone className="w-8 h-8 text-blue-200/40 mx-auto mb-2" />
          <p className="text-blue-100/60 text-sm">Keine aktiven Anzeigen</p>
        </div>
      ) : (
        <div className="space-y-3">
          {ads.map(ad => (
            <a
              key={ad.ad_id}
              href={ad.link_url || "#"}
              target={ad.link_url ? "_blank" : "_self"}
              rel="noopener noreferrer"
              className="block bg-white/[0.04] hover:bg-white/[0.08] border border-white/10 hover:border-[#60a5fa]/40 rounded-2xl p-3 transition-all group"
              data-testid={`inline-ad-${ad.ad_id}`}
            >
              {ad.image_url && (
                <div className="rounded-xl overflow-hidden mb-2 aspect-video bg-[#0A1A3E]">
                  <img src={ad.image_url} alt={ad.title} className="w-full h-full object-cover" />
                </div>
              )}
              <p className="text-[10px] font-bold text-[#60a5fa] uppercase tracking-wider mb-0.5">{ad.sponsor_name || "Sponsor"}</p>
              <p className="text-white font-semibold text-sm leading-tight line-clamp-2">{ad.title}</p>
              {ad.description && (
                <p className="text-blue-100/60 text-xs mt-1 line-clamp-2">{ad.description}</p>
              )}
              {ad.link_url && (
                <p className="flex items-center gap-1 text-[#60a5fa] text-xs mt-2 font-medium group-hover:gap-2 transition-all">
                  Mehr erfahren <ExternalLink className="w-3 h-3" />
                </p>
              )}
            </a>
          ))}
        </div>
      )}
    </div>
  );
};

export default InlineMarketingColumn;
